var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',{staticClass:"pa-4",attrs:{"light":"","type":"list-item-avatar"}}),_c('v-skeleton-loader',{staticClass:"pa-4",attrs:{"light":"","type":"actions"}}),_c('v-skeleton-loader',{staticClass:"pa-4",attrs:{"light":"","type":"card"}}),_c('v-skeleton-loader',{staticClass:"pa-4",attrs:{"light":"","type":"card"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }